import { intl } from './intl';

export const { t: formsT, Message: FormsMessage } = intl.createMessages({
    profile: {
        ru: 'Профиль',
        en: 'Profile',
    },
    selectProfile: {
        ru: 'Выберите профиль',
        en: 'Select profile',
    },
    profilesInfo: {
        ru: 'Подробнее о профилях',
        en: 'More about profiles',
    },
    title: {
        ru: 'Название',
        en: 'Title',
    },
    enterVideoTitle: {
        ru: 'Введите название видео',
        en: 'Enter video title',
    },
    summarization: {
        ru: 'Суммаризация',
        en: 'Summarization',
    },
    enableSummarization: {
        ru: 'Включить суммаризацию?',
        en: 'Enable summarization?',
    },
    selectPlaceholder: {
        ru: 'Выберите',
        en: 'Select',
    },
    titleCannotBeEmpty: {
        ru: 'Название не может быть пустым',
        en: 'Title cannot be empty',
    },
    titleMaxLength: {
        ru: 'Название должно содержать не более {maxLength} символов',
        en: 'Title must contain no more than {maxLength} characters',
    },
    thumbnail: {
        ru: 'Превью',
        en: 'Thumbnail',
    },
    selectThumbnail: {
        ru: 'Выберите превью для видео',
        en: 'Select video thumbnail',
    },
    uploadThumbnail: {
        ru: 'Загрузить превью',
        en: 'Upload thumbnail',
    },
    changeThumbnail: {
        ru: 'Изменить превью',
        en: 'Change thumbnail',
    },
    deleteThumbnail: {
        ru: 'Удалить превью',
        en: 'Delete thumbnail',
    },
    thumbnailUploading: {
        ru: 'Загрузка превью...',
        en: 'Uploading thumbnail...',
    },
    thumbnailRecommendation: {
        ru: 'Поддерживаемые форматы: JPEG, PNG, GIF, WebP. Максимальный размер: 10 МБ',
        en: 'Supported formats: JPEG, PNG, GIF, WebP. Maximum size: 10 MB',
    },
});
